/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_UnrelatedInputs */

const cs_enum_unrelated = /** @type {(inputs: Enum_UnrelatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nesouvisející`)
};

const en_enum_unrelated = /** @type {(inputs: Enum_UnrelatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unrelated`)
};

/**
* | output |
* | --- |
* | "Unrelated" |
*
* @param {Enum_UnrelatedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_unrelated = /** @type {((inputs?: Enum_UnrelatedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_UnrelatedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_unrelated(inputs)
	return cs_enum_unrelated(inputs)
});